import { render, staticRenderFns } from "./DataDic.vue?vue&type=template&id=a095a7cc&"
import script from "./DataDic.vue?vue&type=script&lang=js&"
export * from "./DataDic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports